import { SectionsProvider } from './useSectionsForPreview.tsx';
import { PreviewGridPage } from './previewGrid';
import { PreviewVariablesProvider } from '../../providers/PreviewVariablesContext';
import { useGetPreviewGridByContentId } from './useGetPreviewGridByContentId';
import type { GetDocumentResponse } from 'services/documents/DocumentRepository';

export function PreviewGridInner({ contentId, documentData }: { contentId: string; documentData: GetDocumentResponse }) {
  const { data: sectionData, status: sectionsQueryStatus, userData } = useGetPreviewGridByContentId(contentId);

  return (
    <SectionsProvider sectionData={sectionData} sectionsQueryStatus={sectionsQueryStatus}>
      <PreviewVariablesProvider documentData={documentData}>
        <PreviewGridPage userData={userData} documentData={documentData} />
      </PreviewVariablesProvider>
    </SectionsProvider>
  );
}
